// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductReview_root__5J1k3","review":"ProductReview_review__3nBKQ","rate":"ProductReview_rate__9t2L6","winner":"ProductReview_winner__PNEc5"};